<template>
  <v-dialog v-model="value" persistent max-width="600px" scrollable>
    <v-card v-show="errors.onCreate !== ''" class="box box_error">
      <div class="close">
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <p class="error--text error_title">
        <span>
          <v-icon size="32" color="error">error</v-icon>
        </span>
        Ocurrió un error
      </p>
      <p class="error_text">{{ errors.onCreate }}</p>
    </v-card>
    <v-card v-show="success === true" class="box box_error">
      <!-- <div class="close">
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </div> -->
      <p class="error_title">
        <span class="circle">
          <v-icon size="32" color="success">check</v-icon>
        </span>
        {{ successMessage }}
      </p>
    </v-card>
    <v-card v-show="loading && errors.onCreate === ''" class="box">
      <v-progress-circular
        indeterminate
        color="primary"
        size="65"
      ></v-progress-circular>
    </v-card>
    <v-card v-show="!loading && errors.onCreate === '' && success === false">
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">{{
          flags.isEdit ? 'Editar Chofer' : 'Crear Chofer'
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex order-xs2 order-md2 xs12 md6>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    :error-messages="errors.firstName"
                    v-model="form.firstName"
                    label="Nombre(s)"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :error-messages="errors.lastName"
                    v-model="form.lastName"
                    label="Apellidos"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :error-messages="errors.email"
                    v-model="form.email"
                    label="Correo"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="flags.isEdit === false">
                  <v-checkbox
                    color="primary"
                    v-model="form.sendEmail"
                    label="Enviar el correo de bienvenida al chofer"
                    type="checkbox"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex order-xs1 order-md2 xs8 offset-xs2 md6 offset-md0>
              <v-layout
                align-center
                justify-center
                row
                wrap
                v-on:mouseover="flags.updateImage = true"
                v-on:mouseleave="flags.updateImage = false"
              >
                <v-flex
                  v-show="modals.imageData === ''"
                  xs7
                  style="border-radius: 50%"
                  :class="
                    !flags.changed &&
                    (!driver ||
                    !driver.imageStorage ||
                    !driver.imageStorage.miniObjUrl
                      ? 'gradiente'
                      : '')
                  "
                >
                  <label id="img_edit_employee_default">
                    <v-img
                      v-if="
                        !driver ||
                        !driver.imageStorage ||
                        !driver.imageStorage.miniObjUrl
                      "
                      :src="
                        require('@/assets/panel/modals/AddPhotoIcon@3x.png')
                      "
                    ></v-img>
                    <v-img
                      style="border-radius: 50%; text-align: center"
                      v-else
                      :src="driver.imageStorage.miniObjUrl"
                    ></v-img>
                  </label>
                </v-flex>
                <v-flex v-show="modals.imageData !== ''" xs7>
                  <img :src="modals.imageData" class="image" />
                </v-flex>
                <br />
                <v-flex xs7>
                  <v-expand-transition>
                    <v-btn
                      block
                      class="gradiente"
                      style="border-radius: 33px"
                      v-show="flags.updateImage"
                      dark
                      @click="modals.image = true"
                    >
                      {{
                        !driver ||
                        !driver.imageStorage ||
                        !driver.imageStorage.miniObjUrl
                          ? 'Añadir foto'
                          : 'Actualizar'
                      }}
                    </v-btn>
                  </v-expand-transition>
                  <!-- <v-expand-transition>
                    <v-btn
                      block
                      class="gradiente"
                      style="border-radius: 33px"
                      dark
                    >
                      Borrar
                    </v-btn>
                  </v-expand-transition> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close">Cancelar</v-btn>
        <v-btn
          :disabled="loading || someError()"
          color="primary darken-1"
          flat
          @click="submitHandler"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
    <EditImage v-model="modals.image" v-on:loaded="processImage($event)" />
  </v-dialog>
</template>
<script>
import { EmailUtils } from '../../../utils/genericUtils'
import EditImage from '../EditImage.vue'

export default {
  props: ['title', 'value', 'driver', 'parentId'],
  components: {
    EditImage,
  },
  watch: {
    value: function () {
      if (this.driver) {
        this.form.firstName = this.driver.firstName
        this.form.lastName = this.driver.lastName
        this.form.email = this.driver.mail
        this.flags.isEdit = true
      }
    },
    'form.email': function () {
      this._validateEmail()
    },
    'form.firstName': function () {
      this._validateFirstName()
    },
    'form.lastName': function () {
      this._validateLastName()
    },
  },
  data: () => ({
    flags: {
      updateImage: false,
      isEdit: false,
    },
    success: false,
    successMessage: '',
    errors: {
      onCreate: '',
      firstName: '',
      lastName: '',
      email: '',
    },
    form: {
      firstName: '',
      lastName: '',
      email: '',
      sendEmail: true,
    },
    modals: {
      image: false,
      imageData: '',
    },
    loading: false,
    disableSubmit: true,
  }),
  methods: {
    _reset() {
      this.success = false
      this.errors = {
        firstName: 'campo requerido',
        lastName: 'campo requerido',
        email: 'correo inválido',
        onCreate: '',
      }
      this.form = {
        firstName: '',
        lastName: '',
        email: '',
        sendEmail: true,
      }
      this.modals = {
        image: false,
        imageData: '',
      }
      this.loading = false
      this.flags = {
        updateImage: false,
        isEdit: false,
      }
    },
    _validateEmail() {
      const isValid = EmailUtils.isValidEmail(this.form.email)
      if (isValid) {
        this.errors.email = ''
      } else {
        this.errors.email = 'correo inválido'
      }
    },
    _fieldNotEmpty(value = '') {
      return value.trim() !== ''
    },
    _validateFirstName() {
      const isValid = this._fieldNotEmpty(this.form.firstName)
      if (isValid) {
        this.errors.firstName = ''
      } else {
        this.errors.firstName = 'campo requerido'
      }
    },
    _validateLastName() {
      const isValid = this._fieldNotEmpty(this.form.lastName)
      if (isValid) {
        this.errors.lastName = ''
      } else {
        this.errors.lastName = 'campo requerido'
      }
    },
    async _createDriver() {
      const driver = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        mail: this.form.email,
        sendMailFlag: this.form.sendEmail,
        image: this.modals.imageData.split(',')[1],
      }

      this.loading = true
      try {
        await this.$store.dispatch('tutor/addDriver', {
          id: this.parentId,
          data: driver,
        })
        this.errors.onCreate = ''
        this.successMessage = 'Chofer creado con éxito'
        this.success = true
        return true
      } catch (error) {
        console.log(error)
        const customErrors = {
          1025: {
            code: 1025,
            message: 'Repeated Email',
            userMessage: 'El correo ya está siendo utilizado por un tutor.',
          },
          1137: {
            code: 1137,
            message: 'Email is already being used by another parent',
            userMessage: 'El chofer ya está asociado con el tutor.',
          },
        }
        const customError = error.response.status === 400

        if (customError) {
          this.errors.onCreate =
            customErrors[error.response.data.code].userMessage
        } else {
          this.errors.onCreate = 'Error al crear chofer'
        }

        return undefined
      } finally {
        this.loading = false
      }
    },
    processImage(image) {
      this.modals.imageData = image
    },
    someError() {
      const someError =
        Object.values(this.errors).some((e) => e !== '') ||
        Object.values(this.form).some((e) => e === '')

      return someError
    },
    submitHandler() {
      if (this.flags.isEdit) {
        this._updateDriverHandler()
      } else {
        this._createDriverHandler()
      }
    },
    async _createDriverHandler() {
      const parent = await this._createDriver()
      if (parent !== undefined) {
        const time = setTimeout(() => {
          this.$emit('created', undefined)
          this.close()
          clearTimeout(time)
        }, 1000)
      }
    },
    async _updateDriverHandler() {
      const driver = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        mail: this.form.email,
        image: this.modals.imageData.split(',')[1],
      }
      this.loading = true
      try {
        await this.$store.dispatch('tutor/updateDriver', {
          idDriver: this.driver.id,
          data: driver,
        })
        this.errors.onCreate = ''
        this.successMessage = 'Chofer editado con éxito'
        this.success = true
        const time = setTimeout(() => {
          this.$emit('edited', undefined)
          this.close()
          clearTimeout(time)
        }, 1000)
      } catch (error) {
        console.log(error)
        const customErrors = {
          1025: {
            code: 1025,
            message: 'Repeated Email',
            userMessage: 'El correo ya está siendo utilizado por un tutor.',
          },
          1137: {
            code: 1137,
            message: 'Email is already being used by another parent',
            userMessage: 'El chofer ya está asociado con el tutor.',
          },
        }
        const customError = error.response.status === 400

        if (customError) {
          this.errors.onCreate =
            customErrors[error.response.data.code].userMessage
        } else {
          this.errors.onCreate = 'Error al editar chofer'
        }
      } finally {
        this.loading = false
      }
    },
    close() {
      this.$emit('input', !this.value)
      const time = setTimeout(() => {
        this._reset()
        clearTimeout(time)
      }, 200)
    },
  },
}
</script>

<style scoped>
.close {
  position: absolute;
  top: 10px;
  right: 10px;
}
.box {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box.box_error {
  height: 300px;
}
.error_title {
  font-size: 25px;
}
.error_text {
  font-size: 20px;
}
.circle {
  display: inline-block;
  padding: 6px 8px;
  border-radius: 100%;
  background-color: #d1fae5;
}
.image {
  border-radius: 50%;
  width: 100%;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
</style>
